/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Area_Map_Zoom_HintInputs */

const vi_area_map_zoom_hint = /** @type {(inputs: Area_Map_Zoom_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phóng to để xem vùng trồng`)
};

/**

* @param {Area_Map_Zoom_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const area_map_zoom_hint = /** @type {((inputs?: Area_Map_Zoom_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Area_Map_Zoom_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_area_map_zoom_hint(inputs)
});